import React from 'react';
import {
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IModalBasicProps } from '../../../models/common/modal';
import { IPaymentCardCommonData } from '../../../models/common/payments';
import { getCardImagePath } from '../../../utils/credit-cards';

export interface IAdditionalCardDetailsModalProps {
  card: IPaymentCardCommonData;
  onConfirmEdit: () => void;
  hasHDWallet?: boolean;
}

export const AdditionalCardDetailsModal = ({
  card,
  onConfirmEdit,
  hideModal,
  hasHDWallet,
}: IAdditionalCardDetailsModalProps & IModalBasicProps) => {
  const { cardBrand, cardNumberLast4 } = card;
  return (
    <>
      <ModalHeader onClose={hideModal}>
        Additional Credit Card Details Needed
      </ModalHeader>
      <ModalBody>
        <div className="sui-flex sui-gap-4 sui-flex-col">
          <div className="sui-flex sui-gap-2">
            <img
              width={33}
              height="auto"
              src={getCardImagePath(cardBrand, cardBrand)}
              alt="Credit card logo"
            />
            <Typography> ****{cardNumberLast4}</Typography>
          </div>
          <div>
            <Typography variant="body-base">
              We&apos;re missing information for this card that is needed to
              authorize it for remote purchases
              {hasHDWallet ? ' and HD Pass' : ''}.
            </Typography>
          </div>
          <div>
            <Typography variant="body-base" weight="bold">
              Do you want to edit this card now?
            </Typography>
          </div>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={hideModal}>
            No
          </Button>
          <Button variant="primary" onClick={onConfirmEdit}>
            Yes, Edit Credit Card
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
